<div class="biRepList">
  <p-tabs [value]="selectedTab" (valueChange)="onTabChange($event)" scrollable>
    <div class="biRepTabs">
      <p-tablist>
        @for (tab of tabs; track tab.value) {
        <p-tab [value]="tab.value" class="flex items-center !gap-2">
          <span class="flex gap-1" [id]="tab.Id || ''">
            <p-avatar [image]="tab.icon" />
            <span class="whitespace-nowrap">{{ tab.title }}</span>
          </span>

        </p-tab>
        }
      </p-tablist>
      <div class="inline-flex gap-2 ml-auto" >
        <p-button id="" class="newBI-btn" (click)="setDefaultBtn()" *ngIf="!isCeipalBiUpgraded">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path
              d="M16.3509 7.50011C16.6935 9.18109 16.4494 10.9287 15.6593 12.4515C14.8693 13.9742 13.5811 15.1802 12.0096 15.8681C10.438 16.5561 8.67817 16.6845 7.02342 16.2319C5.36868 15.7793 3.91909 14.7732 2.9164 13.3812C1.91372 11.9892 1.41854 10.2955 1.51344 8.58265C1.60835 6.86977 2.28761 5.24118 3.43793 3.96849C4.58826 2.6958 6.14013 1.85594 7.83475 1.58895C9.52936 1.32197 11.2643 1.64401 12.7502 2.50136M6.7502 8.25011L9.0002 10.5001L16.5002 3.00011"
              stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          Set as Default (New BI)
        </p-button>
        <p-button id="" class="oldBI-btn" (click)="backtoOldBI()" *ngIf="isCeipalBiUpgraded && !hideBackToOldBI">
          Back to Classic BI
        </p-button>
        <p-button id="createReport" label="Create Report" icon="pi pi-plus" (click)="showGenerateReportForm()" />
      </div>
    </div>
    <p-tabpanels>
      <div class="container-fluid">
        <div class="row">
          <!-- Left column: 2 columns on all sizes -->
          <div class="p-0 leftNav" [ngStyle]="{ 'height': leftNavMinHeight }" [ngClass]="sectionsLength?'col-2':''">
            <bi-left-menu [selectedTab]="selectedTab" [sections]="sections()" [activeSection]="activeSection()"
              (sectionClick)="onSectionClick($event)">></bi-left-menu>
          </div>
          <!-- Main content: 8 columns on md and up, full width minus 4 cols on small -->
          <div [ngClass]="sectionsLength?'col-7':'col-9'" class="pt-0 pb-0 padLR rightPanel">
            @for (tab of tabs; track tab.value;let t=$index;) {
            <p-tabpanel [value]="tab.value">
              <div class="BiBox h-full">
                @if(sectionsLength) {
                @for(section of sections();track section;let i=$index;) {
                <div class="BiDivBlc" id="{{section?.id}}">
                  <div class="BiMoTtl mb-3">{{section?.reportName}}</div>
                  <div>
                    @if(section.savedReports.length>0) {
                    @for(report of (section.savedReports);track report;let j=$index;) {
                    <bi-report-item [sectionId]="section.id" [selectedTab]="selectedTab" [reportItem]="report"
                      [currentTab]="t" (updateFavourite)="updateFavourites($event)" (updateUntag)="updateUntag($event)"
                      (deleteReport)="deleteReport($event)" (refreshReportsList)="getReportsList($event)"
                      [module]="section"></bi-report-item>
                    }
                    } @else {
                    <div class="pb-2">No Reports Found.</div>
                    }
                  </div>
                </div>
                }
                } @else {
                <div class="text-center">
                  <img src="assets/images/create-report-icon.svg" alt="">
                  <div class="txtHead1">Choose Your Reports</div>
                  <div class="txtPara">Head to the <span class="hTxt">Reports</span> tab to select the
                    insights that matter most to your business. This quick one-time setup <br />
                    ensures you get faster access to the most relevant data every day.</div>
                  <button pButton label="Create Report" icon="pi pi-plus" class="mt-3"
                    (click)="showGenerateReportForm()"></button>
                </div>
                }
              </div>
            </p-tabpanel>
            }
          </div>
          <!-- Right column: 2 columns on all sizes -->
          <div class="col-3  p-0">

            <bi-favourite-reports [Items]="favoriteReportsList()"
              (updateFavourite)="updateFavourites($event,1)"></bi-favourite-reports>
            <bi-recent-reports (updateFavourite)="updateFavourites($event, 2)"
              [Items]="recentReportsList()"></bi-recent-reports>

          </div>
        </div>
      </div>

    </p-tabpanels>
  </p-tabs>
</div>

<!-- report Security settings start here-->
<div>
  <p-drawer header="Report Security Settings" [(visible)]="visible1" position="right" [style]="{width: '40vw'}">
    <div class="sectWB">
      <div class="sectLab mb-3">View Access Configuration</div>
      <div class="grid">
        <div class="field col-6 inptLP">
          <label>Role</label>
          <p-select [options]="cities" [(ngModel)]="selectedCity" optionLabel="name" placeholder="Amar AI Ranking"
            class="w-full" />
        </div>
        <div class="field col-6 inptLP pl-0">
          <label>Teams</label>
          <p-select [options]="cities" [(ngModel)]="selectedCity" optionLabel="name" placeholder="Job Posting"
            class="w-full" />
        </div>

      </div>
      <div class="flex align-items-center">
        <div class="field pr-3">
          <label>Allow Access for all user</label>
        </div>
        <div class="field">
          <p-toggleswitch [(ngModel)]="checked1" />
        </div>
      </div>
    </div>

    <div class="sectWB">
      <div class="sectLab mb-3">Edit Access Configuration</div>
      <div class="grid">
        <div class="field col-6 inptLP ">
          <label>Role</label>
          <p-select [options]="cities" [(ngModel)]="selectedCity" optionLabel="name" placeholder="Amar AI Ranking"
            class="w-full" />
        </div>
        <div class="field col-6 inptLP pl-0">
          <label>Teams</label>
          <p-select [options]="cities" [(ngModel)]="selectedCity" optionLabel="name" placeholder="Job Posting"
            class="w-full" />
        </div>

      </div>
      <div class="flex align-items-center">
        <div class="field pr-3">
          <label>Allow Access for all user</label>

        </div>
        <div class="field ">
          <p-toggleswitch [(ngModel)]="checked1" />
        </div>
      </div>
      <div class="flex align-items-center">
        <div class="field pr-3">
          <label>Enable access based on hierarchy and reporting?</label>
        </div>
        <div class="field">
          <p-toggleswitch [(ngModel)]="checked1" />
        </div>
      </div>
      <div class="flex align-items-center">
        <div class="field pr-3">
          <label>Notify on Access Change</label>

        </div>
        <div class="field">
          <p-toggleswitch [(ngModel)]="checked1" />
        </div>
      </div>
    </div>
    <ng-template #footer>
      <div class="flex items-center gap-2">
        <button pButton label="Save"></button>
        <button pButton label="Cancel" (click)="visible1 = false" [outlined]="true" severity="secondary"></button>
      </div>
    </ng-template>
  </p-drawer>
</div>
<!-- report Security settings end here-->

<!-- create report popup start here -->
<bi-generate-report-form></bi-generate-report-form>
<!-- <bi-schedule-report></bi-schedule-report>
<bi-report-security></bi-report-security> -->
<!-- create report popup end here -->
<bi-schedule-report (refreshReportsList)="getReportsList(selectedTab)"></bi-schedule-report>
<bi-report-security></bi-report-security>





@if (showPopup()) {
<!-- Mask/Backdrop -->
<div class="popup-mask" (click)="close()">
  <!-- Your Popup Content -->
  <div class="tourSlide" (click)="$event.stopPropagation()">
    <div class="tourSlide-h">
      <span class="rocketIcon">
        <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M34 42.5001V56.6667C34 56.6667 42.585 55.1084 45.3334 51.0001C48.3934 46.4101 45.3334 36.8334 45.3334 36.8334M34 42.5001C37.9574 40.9939 41.7541 39.0956 45.3334 36.8334M34 42.5001L25.5 34.0001M45.3334 36.8334C60.1234 26.9167 62.3334 13.3734 62.3334 5.66672C56.1076 5.6281 49.9754 7.18293 44.5202 10.1833C39.065 13.1837 34.4681 17.5298 31.1667 22.8084M25.5 34.0001C27.0078 30.0884 28.9063 26.3389 31.1667 22.8084M25.5 34.0001H11.3334C11.3334 34.0001 12.8917 25.4151 17 22.6667C21.59 19.6067 31.1667 22.8084 31.1667 22.8084M12.75 46.7501C8.50004 50.3201 7.08337 60.9167 7.08337 60.9167C7.08337 60.9167 17.68 59.5 21.25 55.2501C23.2617 52.8701 23.2334 49.2151 20.995 47.0051C19.8937 45.9539 18.443 45.3465 16.9213 45.2995C15.3997 45.2524 13.9142 45.769 12.75 46.7501Z"
            stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </span>

      <div class="inline-flex ml-auto gap-1 align-items-center">
        <div class="upgradBtn">Upgrade</div>
        <span class="cursor-pointer" (click)="close()">
          <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_3204_16752)">
              <path d="M18.1559 6.05176L6.052 18.1557" stroke="white" />
              <path d="M6.052 6.05176L18.1559 18.1557" stroke="white" />
            </g>
            <defs>
              <clipPath id="clip0_3204_16752">
                <rect width="24.2078" height="24.2078" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>
      </div>
    </div>
    <div class="tourSlide_body">
      <h2 class="tourSlide__title" id="switchnewBI-title">Welcome to New Ceipal BI</h2>
      <p class="tourSlide__intro">
        You are now using the latest version of Ceipal BI. Redesigned from the ground up
        for performance and usability. Key improvements include
      </p>

      <ul class="feature-list">
        <li class="feature-list__item">
          <span class="feature-list__emoji" aria-hidden="true">🚀</span>
          <span><strong>Faster Report Generation</strong> with an optimized backend</span>
        </li>
        <li class="feature-list__item">
          <span class="feature-list__emoji" aria-hidden="true">🤝</span>
          <span><strong>Modernized Interface</strong> built for efficiency and ease of navigation</span>
        </li>
        <li class="feature-list__item">
          <span class="feature-list__emoji" aria-hidden="true">⚡</span>
          <span><strong>Improved Scalability</strong> to support growing data needs</span>
        </li>
      </ul>

      <div class="info-box" role="note">
        <p class="info-box__text">
          Your existing Reports, Dashboards, and Preferences have been carried over seamlessly.
        </p>
      </div>

    </div>
    <div class="tourSlide_footer">
      <p-button (click)="close()" label="Close" variant="outlined" severity="secondary" />
      <p-button (click)="startTakeTour()">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_3204_16777)">
            <path
              d="M6.62467 10.3332C6.56515 10.1025 6.44489 9.89191 6.27641 9.72343C6.10793 9.55495 5.89738 9.43469 5.66667 9.37517L1.57667 8.32051C1.50689 8.3007 1.44547 8.25867 1.40174 8.2008C1.35801 8.14293 1.33435 8.07238 1.33435 7.99984C1.33435 7.9273 1.35801 7.85675 1.40174 7.79888C1.44547 7.74101 1.50689 7.69898 1.57667 7.67917L5.66667 6.62384C5.8973 6.56438 6.1078 6.44422 6.27627 6.27587C6.44474 6.10751 6.56504 5.8971 6.62467 5.66651L7.67933 1.57651C7.69894 1.50645 7.74092 1.44474 7.79888 1.40077C7.85684 1.35681 7.92759 1.33301 8.00033 1.33301C8.07308 1.33301 8.14383 1.35681 8.20179 1.40077C8.25974 1.44474 8.30173 1.50645 8.32133 1.57651L9.37533 5.66651C9.43485 5.89722 9.55511 6.10777 9.72359 6.27625C9.89207 6.44473 10.1026 6.56499 10.3333 6.62451L14.4233 7.67851C14.4937 7.69791 14.5557 7.73985 14.5999 7.79789C14.6441 7.85594 14.668 7.92688 14.668 7.99984C14.668 8.0728 14.6441 8.14374 14.5999 8.20179C14.5557 8.25983 14.4937 8.30177 14.4233 8.32117L10.3333 9.37517C10.1026 9.43469 9.89207 9.55495 9.72359 9.72343C9.55511 9.89191 9.43485 10.1025 9.37533 10.3332L8.32067 14.4232C8.30106 14.4932 8.25908 14.5549 8.20112 14.5989C8.14316 14.6429 8.07241 14.6667 7.99967 14.6667C7.92692 14.6667 7.85617 14.6429 7.79821 14.5989C7.74026 14.5549 7.69827 14.4932 7.67867 14.4232L6.62467 10.3332Z"
              stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M13.3334 2V4.66667" stroke="white" stroke-width="1.33333" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M14.6667 3.3335H12" stroke="white" stroke-width="1.33333" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M2.66663 11.3335V12.6668" stroke="white" stroke-width="1.33333" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M3.33333 12H2" stroke="white" stroke-width="1.33333" stroke-linecap="round"
              stroke-linejoin="round" />
          </g>
          <defs>
            <clipPath id="clip0_3204_16777">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
        Start Exploring
      </p-button>

    </div>
  </div>
</div>
}




@if (showPopup2()) {
<div class="popup-mask" (click)="close()">
  <div class="switchnewBI">

    <!-- Header -->
    <div class="switchnewBI-header">
      <div class="header-icon">
        <!-- Sparkle / star icon -->
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <g clip-path="url(#clip0_3145_16077)">
            <path
              d="M8.28086 12.9167C8.20647 12.6283 8.05615 12.3651 7.84555 12.1545C7.63494 11.9439 7.37176 11.7936 7.08336 11.7192L1.97086 10.4009C1.88364 10.3761 1.80687 10.3236 1.75221 10.2512C1.69754 10.1789 1.66797 10.0907 1.66797 10C1.66797 9.90937 1.69754 9.82118 1.75221 9.74884C1.80687 9.6765 1.88364 9.62397 1.97086 9.59921L7.08336 8.28004C7.37166 8.20572 7.63477 8.05552 7.84537 7.84508C8.05596 7.63463 8.20634 7.37162 8.28086 7.08338L9.5992 1.97088C9.6237 1.88331 9.67618 1.80616 9.74863 1.75121C9.82108 1.69625 9.90951 1.6665 10.0004 1.6665C10.0914 1.6665 10.1798 1.69625 10.2523 1.75121C10.3247 1.80616 10.3772 1.88331 10.4017 1.97088L11.7192 7.08338C11.7936 7.37177 11.9439 7.63496 12.1545 7.84556C12.3651 8.05616 12.6283 8.20648 12.9167 8.28088L18.0292 9.59838C18.1171 9.62263 18.1946 9.67505 18.2499 9.74761C18.3052 9.82016 18.3351 9.90884 18.3351 10C18.3351 10.0912 18.3052 10.1799 18.2499 10.2525C18.1946 10.325 18.1171 10.3775 18.0292 10.4017L12.9167 11.7192C12.6283 11.7936 12.3651 11.9439 12.1545 12.1545C11.9439 12.3651 11.7936 12.6283 11.7192 12.9167L10.4009 18.0292C10.3764 18.1168 10.3239 18.1939 10.2514 18.2489C10.179 18.3038 10.0905 18.3336 9.99961 18.3336C9.90868 18.3336 9.82025 18.3038 9.7478 18.2489C9.67535 18.1939 9.62287 18.1168 9.59836 18.0292L8.28086 12.9167Z"
              stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16.667 2.5V5.83333" stroke="white" stroke-width="1.66667" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M18.3333 4.1665H15" stroke="white" stroke-width="1.66667" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M3.33301 14.1665V15.8332" stroke="white" stroke-width="1.66667" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M4.16667 15H2.5" stroke="white" stroke-width="1.66667" stroke-linecap="round"
              stroke-linejoin="round" />
          </g>
          <defs>
            <clipPath id="clip0_3145_16077">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <h2 class="switchnewBI-title">Switch to New BI UI?</h2>
      <button class="close-btn" aria-label="Close">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
          stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>

    <!-- Description -->
    <p class="switchnewBI-desc">
      You are about to set the <strong>New BI</strong> user interface as your default
      experience. The previous <strong>Old BI</strong> UI will no longer be your default,
      but you can switch back anytime from settings.
    </p>

    <!-- Feature cards -->
    <div class="features">

      <!-- Card 1 – Orange -->
      <div class="feature-card orange">
        <span class="feature-icon orange">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
            stroke-linecap="round" stroke-linejoin="round">
            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
          </svg>
        </span>
        Faster performance &amp; loading times
      </div>

      <!-- Card 2 – Purple -->
      <div class="feature-card purple">
        <span class="feature-icon purple">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <g clip-path="url(#clip0_3145_16102)">
              <path
                d="M11.2497 5.83333C11.4798 5.83333 11.6663 5.64679 11.6663 5.41667C11.6663 5.18655 11.4798 5 11.2497 5C11.0196 5 10.833 5.18655 10.833 5.41667C10.833 5.64679 11.0196 5.83333 11.2497 5.83333Z"
                fill="#9810FA" stroke="#9810FA" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M14.5837 9.16683C14.8138 9.16683 15.0003 8.98028 15.0003 8.75016C15.0003 8.52004 14.8138 8.3335 14.5837 8.3335C14.3535 8.3335 14.167 8.52004 14.167 8.75016C14.167 8.98028 14.3535 9.16683 14.5837 9.16683Z"
                fill="#9810FA" stroke="#9810FA" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M7.08366 6.66683C7.31378 6.66683 7.50033 6.48028 7.50033 6.25016C7.50033 6.02004 7.31378 5.8335 7.08366 5.8335C6.85354 5.8335 6.66699 6.02004 6.66699 6.25016C6.66699 6.48028 6.85354 6.66683 7.08366 6.66683Z"
                fill="#9810FA" stroke="#9810FA" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M5.41667 10.8333C5.64679 10.8333 5.83333 10.6468 5.83333 10.4167C5.83333 10.1865 5.64679 10 5.41667 10C5.18655 10 5 10.1865 5 10.4167C5 10.6468 5.18655 10.8333 5.41667 10.8333Z"
                fill="#9810FA" stroke="#9810FA" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M10.0003 1.6665C5.41699 1.6665 1.66699 5.4165 1.66699 9.99984C1.66699 14.5832 5.41699 18.3332 10.0003 18.3332C10.772 18.3332 11.3737 17.7115 11.3737 16.9265C11.3737 16.5623 11.2237 16.2307 11.0095 15.989C10.7678 15.7482 10.6445 15.4457 10.6445 15.0515C10.6413 14.8681 10.6751 14.6859 10.7439 14.5159C10.8126 14.3458 10.9149 14.1913 11.0446 14.0616C11.1743 13.9319 11.3288 13.8296 11.4988 13.7609C11.6689 13.6921 11.8511 13.6583 12.0345 13.6615H13.6978C16.2403 13.6615 18.327 11.5757 18.327 9.03317C18.3045 5.00984 14.5512 1.6665 10.0003 1.6665Z"
                stroke="#9810FA" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
              <clipPath id="clip0_3145_16102">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>
        Modern, improved design
      </div>

      <!-- Card 3 – Green -->
      <div class="feature-card green">
        <span class="feature-icon green">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
            stroke-linecap="round" stroke-linejoin="round">
            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
            <polyline points="17 6 23 6 23 12" />
          </svg>
        </span>
        Enhanced insights &amp; analytics
      </div>

    </div>

    <!-- Footer note -->
    <p class="switchnewBI-note">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path
          d="M8.14667 1.3335H7.85333C7.49971 1.3335 7.16057 1.47397 6.91053 1.72402C6.66048 1.97407 6.52 2.31321 6.52 2.66683V2.78683C6.51976 3.02065 6.45804 3.25029 6.34103 3.45272C6.22401 3.65515 6.05583 3.82325 5.85333 3.94016L5.56667 4.10683C5.36398 4.22385 5.13405 4.28546 4.9 4.28546C4.66595 4.28546 4.43603 4.22385 4.23333 4.10683L4.13333 4.0535C3.82738 3.877 3.46389 3.82913 3.12267 3.92037C2.78145 4.01161 2.49037 4.23452 2.31333 4.54016L2.16667 4.7935C1.99018 5.09945 1.9423 5.46294 2.03354 5.80416C2.12478 6.14539 2.34769 6.43646 2.65333 6.6135L2.75333 6.68016C2.95485 6.7965 3.12241 6.96356 3.23937 7.16472C3.35632 7.36588 3.4186 7.59414 3.42 7.82683V8.16683C3.42093 8.40178 3.35977 8.6328 3.2427 8.8365C3.12563 9.04021 2.95681 9.20936 2.75333 9.32683L2.65333 9.38683C2.34769 9.56386 2.12478 9.85494 2.03354 10.1962C1.9423 10.5374 1.99018 10.9009 2.16667 11.2068L2.31333 11.4602C2.49037 11.7658 2.78145 11.9887 3.12267 12.08C3.46389 12.1712 3.82738 12.1233 4.13333 11.9468L4.23333 11.8935C4.43603 11.7765 4.66595 11.7149 4.9 11.7149C5.13405 11.7149 5.36398 11.7765 5.56667 11.8935L5.85333 12.0602C6.05583 12.1771 6.22401 12.3452 6.34103 12.5476C6.45804 12.75 6.51976 12.9797 6.52 13.2135V13.3335C6.52 13.6871 6.66048 14.0263 6.91053 14.2763C7.16057 14.5264 7.49971 14.6668 7.85333 14.6668H8.14667C8.50029 14.6668 8.83943 14.5264 9.08948 14.2763C9.33953 14.0263 9.48 13.6871 9.48 13.3335V13.2135C9.48024 12.9797 9.54196 12.75 9.65898 12.5476C9.77599 12.3452 9.94418 12.1771 10.1467 12.0602L10.4333 11.8935C10.636 11.7765 10.866 11.7149 11.1 11.7149C11.3341 11.7149 11.564 11.7765 11.7667 11.8935L11.8667 11.9468C12.1726 12.1233 12.5361 12.1712 12.8773 12.08C13.2186 11.9887 13.5096 11.7658 13.6867 11.4602L13.8333 11.2002C14.0098 10.8942 14.0577 10.5307 13.9665 10.1895C13.8752 9.84827 13.6523 9.5572 13.3467 9.38016L13.2467 9.32683C13.0432 9.20936 12.8744 9.04021 12.7573 8.8365C12.6402 8.6328 12.5791 8.40178 12.58 8.16683V7.8335C12.5791 7.59855 12.6402 7.36753 12.7573 7.16382C12.8744 6.96012 13.0432 6.79097 13.2467 6.6735L13.3467 6.6135C13.6523 6.43646 13.8752 6.14539 13.9665 5.80416C14.0577 5.46294 14.0098 5.09945 13.8333 4.7935L13.6867 4.54016C13.5096 4.23452 13.2186 4.01161 12.8773 3.92037C12.5361 3.82913 12.1726 3.877 11.8667 4.0535L11.7667 4.10683C11.564 4.22385 11.3341 4.28546 11.1 4.28546C10.866 4.28546 10.636 4.22385 10.4333 4.10683L10.1467 3.94016C9.94418 3.82325 9.77599 3.65515 9.65898 3.45272C9.54196 3.25029 9.48024 3.02065 9.48 2.78683V2.66683C9.48 2.31321 9.33953 1.97407 9.08948 1.72402C8.83943 1.47397 8.50029 1.3335 8.14667 1.3335Z"
          stroke="#4A5565" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
          stroke="#4A5565" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
      </svg>

      You can change this anytime in settings
    </p>

    <!-- Actions -->
    <div class="switchnewBI-actions">
      <button class="btn btn-cancel" (click)="close()">Cancel</button>
      <button class="btn btn-primary" (click)="changeDefaultSetting()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <g clip-path="url(#clip0_3145_16962)">
            <path
              d="M14.5341 6.66666C14.8385 8.16086 14.6215 9.71428 13.9193 11.0679C13.2171 12.4214 12.072 13.4934 10.6751 14.1049C9.27816 14.7164 7.71382 14.8305 6.24293 14.4282C4.77205 14.026 3.48353 13.1316 2.59225 11.8943C1.70097 10.657 1.26081 9.15148 1.34518 7.62892C1.42954 6.10635 2.03332 4.65872 3.05583 3.52744C4.07835 2.39616 5.45779 1.64961 6.96411 1.4123C8.47043 1.17498 10.0126 1.46123 11.3334 2.22333M6.00007 7.33333L8.00007 9.33333L14.6667 2.66666"
              stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
          </g>
          <defs>
            <clipPath id="clip0_3145_16962">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
        Set as Default
      </button>
    </div>

  </div>
</div>

}